import React from 'react'
import moment from 'moment'

import {Badge, Colors, S1, P, IconButton, Row, Icon, Popup} from '../../src/components/UI/index.js'
import OrderActions from '../actions/OrderActions.js'
import utils from '../utils/utils.js'
import {emit} from 'messenger/socketio/socketEmit.js'
import stopBundles from '../../utils/stopBundles.js'
import {OptionIcons, CustomOptionBadges} from './OptionIcons.js'
import t from 'src/helpers/Languages.js'

// One row in the address list for a bundle of stops at the same address
export default class AddressBundle extends React.Component {
    constructor(props) {
        super(props)

        this.state = {expanded: false}
    }

    async onClickLock(event) {
        const {route, bundle} = this.props

        event.stopPropagation()

        if (route.ready && bundle.locked) {
            if (!await this.popup.open(t('changeRoute'), t('unlockReadyRouteConfirm'))) return

            await new Promise((resolve) => {
                OrderActions.setRouteReady(route._id, false, (err) => {
                    if (err) {
                        this.popup.setError(err)
                    } else {
                        resolve()
                    }
                })
            })
        }

        // Locking applies to all stops of the bundle
        const errors = await Promise.all(bundle.addresses.map((address) => new Promise((resolve) => {
            OrderActions.setAddressLocked(address.orderId, address.index, !bundle.locked, resolve)
        })))

        const error = errors.find(Boolean)

        if (error) {
            this.popup.setError(error)
        } else {
            this.popup.close()
        }
    }

    async onClickRemove(address) {
        if (!await this.popup.open(t('removeStop'), t('removeStopConfirm'))) return

        try {
            await emit('orders.removeMessengerOrder', address.orderId)
            this.popup.close()
        } catch (err) {
            this.popup.setError(err instanceof Error ? err.message : String(err))
        }
    }

    render() {
        const {reseller, route, bundle, compact, editRoute, disabled, onClick, onClickAddress, onClickNavigation, onClickMap} = this.props
        const {expanded} = this.state

        const firstAddress = bundle.addresses[0]
        const isReady = !disabled && bundle.isReady && utils.nextStopDeviation(reseller, bundle) !== 'notallowed'
        const color = isReady ? Colors.textDark : Colors.textMedium
        const options = stopBundles.combineOptions(bundle.addresses)

        return (
            <div style={{display: 'flex', flexDirection: 'column', width: 'calc(100% - 6px)', flexShrink: 0, marginTop: 6}}>
                <div style={{display: 'flex', width: '100%'}}>
                    <div style={{height: 36, width: 6, borderRadius: '4px 0px 0px 4px', background: Colors[bundle.type]}} />

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            width: '100%',
                            background: Colors.backgroundWhite,
                            borderBottom: `solid 1px ${Colors.grey20}`,
                            overflow: 'hidden',
                            paddingTop: 3
                        }}
                        onClick={isReady && !editRoute ? onClick : () => {}}
                    >
                        <Row style={{paddingLeft: 6, paddingRight: 6, alignItems: 'center', minWidth: 'auto'}}>
                            <S1 translate='no' style={{minWidth: 20, color, marginRight: 6, textAlign: 'center'}}>{firstAddress.stopNumber || ''}</S1>

                            <div style={{display: 'flex', flex: 1, minWidth: 0}}>
                                <S1 ellipsis translate='no' style={{minWidth: 0, maxWidth: '100%', color}}>{firstAddress.street}&nbsp;</S1>
                                <S1 translate='no' style={{color, marginRight: 6, flexShrink: 0}}>{`${firstAddress.nr}${firstAddress.addition}${compact && firstAddress.city ? `, ${firstAddress.city}` : ''}`}</S1>
                            </div>

                            {firstAddress.plannedTimeOfArrival ?
                                <>
                                    <Icon style={{marginRight: 6, marginLeft: 24, color}} icon='mdi mdi-clock-outline' />
                                    <P translate='no' style={{color}}>{moment(firstAddress.plannedTimeOfArrival, 'HH:mm').format('HH:mm')}</P>
                                </> :
                                <P translate='no' style={{color}} ellipsis>{`${firstAddress.startTime} - ${firstAddress.endTime}`}</P>
                            }
                        </Row>

                        <Row style={{paddingLeft: 6}}>
                            <S1 style={{minWidth: 20, color, marginRight: 6, textAlign: 'center'}}>
                                {editRoute && firstAddress.stopNumber &&
                                    <Icon
                                        style={{marginRight: 6}}
                                        icon={bundle.locked ? 'mdi mdi-lock' : 'mdi mdi-lock-open-variant-outline'}
                                        onClick={this.onClickLock.bind(this)}
                                    />
                                }
                            </S1>

                            <div style={{flex: 1, minWidth: 0, paddingBottom: 6}}>
                                {!compact &&
                                    <P ellipsis translate='no' style={{color, marginBottom: 12}}>{`${firstAddress.postalCode} ${firstAddress.city}`}</P>
                                }

                                <OptionIcons options={options} colliCount={bundle.colliCount} color={color} />
                                <CustomOptionBadges style={{marginTop: 2}} reseller={reseller} customOptions={options.customOptions} />
                            </div>

                            <div style={{display: 'flex', alignItems: 'flex-end', paddingLeft: 6, paddingRight: 6}} onClick={(event) => event.stopPropagation()}>
                                {editRoute && bundle.anchor &&
                                    <Icon style={{marginRight: 6, marginBottom: 6}} icon='mdi mdi-anchor' />
                                }

                                {!editRoute && firstAddress.isStarted &&
                                    <Row style={{flexShrink: 0, justifyContent: 'flex-end', marginBottom: 6}}>
                                        {onClickMap &&
                                            <IconButton style={{marginRight: 12}} disabled={!bundle.isReady} onClick={onClickMap}>
                                                <Icon style={{marginRight: 6, fontSize: 24}} icon='mdi mdi-map' />
                                            </IconButton>
                                        }

                                        <IconButton disabled={!bundle.isReady} onClick={() => onClickNavigation(firstAddress)}>
                                            <Icon style={{marginRight: 6, fontSize: 24}} icon='mdi mdi-navigation-outline' />
                                        </IconButton>
                                    </Row>
                                }
                            </div>
                        </Row>

                        <Row
                            style={{alignItems: 'center', justifyContent: 'space-between', padding: '6px 12px', borderTop: `solid 1px ${Colors.grey20}`, background: Colors.backgroundWhite}}
                            onClick={(event) => {
                                event.stopPropagation()
                                this.setState({expanded: !expanded})
                            }}
                        >
                            <Badge style={{opacity: isReady ? 1 : 0.6, fontWeight: 'bold'}} color={bundle.type === 'pickup' ? Colors.pickupLight : Colors.deliveryLight}>
                                {t('bundleStops', bundle.addresses.length)}
                            </Badge>

                            {!editRoute &&
                                <Row style={{width: 'unset', alignItems: 'center'}}>
                                    <P style={{color}}>{expanded ? t('hideStops') : t('showStops')}</P>
                                    <Icon style={{marginRight: 6, color, fontSize: 20}} icon={expanded ? 'mdi mdi-chevron-up' : 'mdi mdi-chevron-down'} />
                                </Row>
                            }
                        </Row>
                    </div>
                </div>

                {/* Stacked edges to show that more stops are below this row */}
                {!expanded &&
                    <>
                        <div style={{height: 3, margin: '0 6px 0 12px', background: Colors.backgroundWhite, borderBottom: `solid 1px ${Colors.grey20}`, borderLeft: `solid 1px ${Colors.grey20}`, borderRight: `solid 1px ${Colors.grey20}`}} />
                        <div style={{height: 3, margin: '0 12px 0 18px', background: Colors.backgroundWhite, borderBottom: `solid 1px ${Colors.grey20}`, borderLeft: `solid 1px ${Colors.grey20}`, borderRight: `solid 1px ${Colors.grey20}`}} />
                    </>
                }

                {expanded &&
                    <div style={{display: 'flex', flexDirection: 'column', marginLeft: 12}}>
                        {bundle.addresses.map((address) => {
                            const addressReady = !disabled && address.isReady && utils.nextStopDeviation(reseller, address) !== 'notallowed'
                            const addressColor = addressReady ? Colors.textDark : Colors.textMedium
                            const {status, statusColor} = Colors.addressStatusColor(address, address.colli)
                            const removable = editRoute && !address.hasArrived && route?.orders?.[address.orderId]?.createdByMessenger

                            return (
                                <div
                                    key={address.id}
                                    style={{display: 'flex', flexDirection: 'column', padding: 6, background: Colors.backgroundWhite, borderBottom: `solid 1px ${Colors.grey20}`, borderLeft: `solid 3px ${Colors[address.type]}`}}
                                    onClick={addressReady && !editRoute ? () => onClickAddress(address) : () => {}}
                                >
                                    <Row style={{alignItems: 'center'}}>
                                        <Icon style={{marginRight: 6, fontSize: 20, color: addressColor}} icon={address.isBusiness ? 'mdi mdi-store-outline' : 'mdi mdi-account-outline'} />

                                        <div style={{flex: 1, minWidth: 0}}>
                                            <P ellipsis translate='no' style={{color: addressColor}}>{address.name}</P>

                                            {address.attention &&
                                                <P ellipsis translate='no' style={{color: addressColor}}>{address.attention}</P>
                                            }
                                        </div>

                                        {!address.isReady && status &&
                                            <Row style={{alignItems: 'center', justifyContent: 'center', background: statusColor, width: 'fit-content', padding: '6px 12px'}}>
                                                <P ellipsis onDark={Colors.isDarkBackground(statusColor)}>{status}</P>
                                            </Row>
                                        }

                                        {removable &&
                                            <IconButton
                                                onClick={(event) => {
                                                    event.stopPropagation()
                                                    this.onClickRemove(address)
                                                }}
                                            >
                                                <Icon icon='mdi mdi-delete' style={{margin: 0}} />
                                            </IconButton>
                                        }
                                    </Row>

                                    <Row style={{alignItems: 'center'}}>
                                        <Icon style={{marginRight: 6, fontSize: 20, color: addressColor}} icon='mdi mdi-send' />

                                        <P ellipsis style={{color: addressColor}}>
                                            {`${address.type === 'pickup' ? t('principal') : t('consignor')}: `}
                                            <span translate='no'>{address.senderAddress?.name || address.customerAddress?.name}</span>
                                        </P>
                                    </Row>

                                    <OptionIcons style={{marginLeft: 20}} options={address} colliCount={address.colli?.length} color={addressColor} />
                                    <CustomOptionBadges style={{marginLeft: 20, marginTop: 2}} reseller={reseller} customOptions={address.customOptions} />
                                </div>
                            )
                        })}
                    </div>
                }

                <Popup ref={(ref) => this.popup = ref} />
            </div>
        )
    }
}
